import { FC, useState } from 'react';

import { kebabCase } from 'utils/stringHelpers';
import { Popover, PopoverContent, DefaultTriggerIcon } from 'ui/popover';
import { AiLight24 } from 'ui/icons';
import { colors } from 'ui/theme';

import {
  NBACardHeader,
  NBACardHeaderInfo,
  NBACardToggleContent,
  NBACardHeaderTrigger,
} from './CampaignNBA.styles';

export interface CampaignNBACardHeaderProps {
  popoverContent: React.ReactNode;
  title: string;
}
export const CampaignNBACardHeader: FC<React.PropsWithChildren<CampaignNBACardHeaderProps>> = ({
  title,
  popoverContent,
}) => {
  const [popoverOpen, togglePopoverOpen] = useState(false);
  return (
    <NBACardHeader data-test={`campaigns-nba-card-header-${kebabCase(title)}`}>
      <NBACardHeaderInfo>
        <AiLight24 />
        {title}
      </NBACardHeaderInfo>
      <Popover onOpenChange={togglePopoverOpen}>
        <PopoverContent side="top">
          <NBACardToggleContent color={colors.textSecondary}>{popoverContent}</NBACardToggleContent>
        </PopoverContent>
        <NBACardHeaderTrigger Icon={DefaultTriggerIcon} isOpen={popoverOpen} />
      </Popover>
    </NBACardHeader>
  );
};
